import { render, staticRenderFns } from "./WithdrawalTransfer.vue?vue&type=template&id=37df008c"
import script from "./WithdrawalTransfer.vue?vue&type=script&lang=js"
export * from "./WithdrawalTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports